// Certificate status and action type
export const DOCUMENT_STATUS = {
  REVOKE: "REVOKE",
  ISSUED: "ISSUED",
};

export const DOCUMENT_ACTION_TYPE = {
  REVOKE: "REVOKE",
  ISSUE_NEW_CERT: "ISSUE_NEW_CERT",
};

export enum DocumentStatus {
  // Revoke = "Bị thu hồi",
  // Issued = "Còn hiệu lực",
  // Expired = "Hết hiệu lực",
  Revoke = "Revoked",
  Issued = "Valid",
  Expired = "Expired",
}

export enum DocumentAction {
  // Revoke = "Thu hồi",
  // Issued = "Cấp mới",
  Revoke = "Revoked",
  Issued = "Issued",
}

// Common edit field, include another template in future
export const CAN_EDIT_FIELDS = [
  // Template 45
  "reg_first_time",
  "reg_update_times",
  "org_name",
  "org_eng_name",
  "symbol",
  "headquarters",
  "operating_loc",
  "total_registered_capital",
  "fixed_capital",
  "working_capital",
  "decision_establishment",
  "direct_management_authority",
  "personal_name",
  "id_card",
  "issued_by",
  "issued_date",
  "registration_code",
  "activities",
];

///////////////////////////// KHCN-001 - TEMPLATE 45 /////////////////////////////////
export const TEMPLATE_45_FIELD = {
  reg_first_time: {
    title: "Đăng ký lần đầu ngày",
    value: "reg_first_time",
    section: "1a",
  },
  reg_update_times: {
    title: "Đăng ký thay đổi lần",
    value: "reg_update_times",
    section: "1b",
  },
  org_name: {
    title: "Tên tổ chức khoa học và công nghệ",
    value: "org_name",
    section: "2",
  },
  org_eng_name: {
    title: "Tên viết bằng tiếng Anh",
    value: "org_eng_name",
    section: "3",
  },
  symbol: {
    title: "Tên viết tắt bằng tiếng Anh",
    value: "symbol",
    section: "4",
  },
  headquarters: {
    title: "Trụ sở chính",
    value: "headquarters",
    section: "5",
  },
  operating_loc: {
    title: "Địa điểm hoạt động",
    value: "operating_loc",
    section: "6",
  },
  total_registered_capital: {
    title: "Tổng số vốn đăng ký",
    value: "total_registered_capital",
    section: "7",
  },
  fixed_capital: {
    title: "Vốn cố định",
    value: "fixed_capital",
    section: "7a",
  },
  working_capital: {
    title: "Vốn lưu động",
    value: "working_capital",
    section: "7b",
  },
  decision_establishment: {
    title: "Cơ quan quyết định thành lập",
    value: "decision_establishment",
    section: "8",
  },
  direct_management_authority: {
    title: "Cơ quan quản lý trực tiếp",
    value: "direct_management_authority",
    section: "9",
  },
  personal_name: {
    title: "Họ và tên",
    value: "personal_name",
    section: "10a",
  },
  id_card: {
    title: "Căn cước công dân số",
    value: "id_card",
    section: "10b",
  },
  issued_by: {
    title: "Nơi cấp",
    value: "issued_by",
    section: "10c",
  },
  issued_date: {
    title: "Ngày cấp",
    value: "issued_date",
    section: "10d",
  },
  registration_code: {
    title: "Số đăng ký",
    value: "registration_code",
    section: "11",
  },
  activities: {
    title: "Hoạt động trong lĩnh vực khoa học và công nghệ sau",
    value: "activities",
    section: "12",
  },
  activity_one: {
    title: "Hoạt động trong lĩnh vực khoa học và công nghệ (1)",
    value: "activity_one",
    section: "12a",
  },
  activity_two: {
    title: "Hoạt động trong lĩnh vực khoa học và công nghệ (2)",
    value: "activity_two",
    section: "12b",
  },
  activity_three: {
    title: "Hoạt động trong lĩnh vực khoa học và công nghệ (3)",
    value: "activity_three",
    section: "12c",
  },
  signer: {
    title: "Người ký",
    value: "signer",
    section: "",
  },
  sign_time: {
    title: "Thời gian ký",
    value: "sign_time",
    section: "",
  },
};

export const TEMPLATE_45_RAW_DATA = {
  [TEMPLATE_45_FIELD.reg_first_time.value]: {
    text: "08/01/1997",
    html: "08/01/1997",
  },
  [TEMPLATE_45_FIELD.reg_update_times.value]: {
    text: "10 ngày 22/12/2023",
    html: "10 ngày 22/12/2023",
  },
  [TEMPLATE_45_FIELD.org_name.value]: {
    text: "TRUNG TÂM ĐÀO TẠO VÀ PHÁT TRIỂN SẮC KÝ",
    html: "TRUNG TÂM ĐÀO TẠO VÀ PHÁT TRIỂN SẮC KÝ",
  },
  [TEMPLATE_45_FIELD.org_eng_name.value]: {
    text: "CENTER FOR EDUCATION AND DEVELOPMENT OF CHROMATOGRAPHY",
    html: "CENTER FOR EDUCATION AND DEVELOPMENT OF CHROMATOGRAPHY",
  },
  [TEMPLATE_45_FIELD.symbol.value]: {
    text: "EDC-HCM",
    html: "EDC-HCM",
  },
  [TEMPLATE_45_FIELD.headquarters.value]: {
    text: "Văn phòng 02, Tầng 08, Tòa nhà Pearl Plaza, số 561 Điện Biên Phủ, Phường 25, Quận Bình Thạnh, Thành phố Hồ Chí Minh",
    html: "Văn phòng 02, Tầng 08, Tòa nhà Pearl Plaza, số 561 Điện Biên Phủ, Phường 25, Quận Bình Thạnh, Thành phố Hồ Chí Minh",
  },
  [TEMPLATE_45_FIELD.operating_loc.value]: {
    text: "- 54 Nguyễn Văn Kỉnh, KP1, Phường Thạnh Mỹ Lợi, thành phố Thủ Đức, Thành phố Hồ Chí Minh.\n- 114 Trương Văn Bang, phường Thành Mỹ Lợi, thành phố Thủ Đức, Thành phố Hồ Chí Minh.",
    html: `<div style="font-family: Times New Roman, sans-serif">- 54 Nguyễn Văn Kỉnh, KP1, Phường Thạnh Mỹ Lợi, thành phố Thủ Đức, Thành phố Hồ Chí Minh.</div><div style="font-family: Times New Roman, sans-serif">- 114 Trương Văn Bang, phường Thành Mỹ Lợi, thành phố Thủ Đức, Thành phố Hồ Chí Minh.</div>`,
  },
  [TEMPLATE_45_FIELD.total_registered_capital.value]: {
    text: "3.941.200.000 đồng",
    html: "3.941.200.000 đồng",
  },
  [TEMPLATE_45_FIELD.fixed_capital.value]: {
    text: "1.941.200.000 đồng",
    html: "1.941.200.000 đồng",
  },
  [TEMPLATE_45_FIELD.working_capital.value]: {
    text: "2.000.000.000 đồng",
    html: "2.000.000.000 đồng",
  },
  [TEMPLATE_45_FIELD.decision_establishment.value]: {
    text: "Không có, Tổ chức thành lập theo Biên bản họp Hội đồng sáng lập ngày 28/7/1997 và Biên bản họp Hội đồng thành viên ngày 24/01/2024",
    html: "Không có, Tổ chức thành lập theo Biên bản họp Hội đồng sáng lập ngày 28/7/1997 và Biên bản họp Hội đồng thành viên ngày 24/01/2024",
  },
  [TEMPLATE_45_FIELD.direct_management_authority.value]: {
    text: "Không có, “Tổ chức do cá nhân thành lập”",
    html: "Không có, “Tổ chức do cá nhân thành lập”",
  },
  [TEMPLATE_45_FIELD.personal_name.value]: {
    text: "Diệp Ngọc Sương",
    html: `Diệp Ngọc Sương`,
  },
  [TEMPLATE_45_FIELD.id_card.value]: {
    text: "079142008759",
    html: "079142008759",
  },
  [TEMPLATE_45_FIELD.issued_by.value]: {
    text: "Cục Cảnh sát Quản lý Hành chính về Trật tự Xã hội",
    html: "Cục Cảnh sát Quản lý Hành chính về Trật tự Xã hội",
  },
  [TEMPLATE_45_FIELD.issued_date.value]: {
    text: "09/07/2021",
    html: "09/07/2021",
  },
  [TEMPLATE_45_FIELD.registration_code.value]: {
    text: "45",
    html: `45`,
  },
  [TEMPLATE_45_FIELD.activity_one.value]: {
    text: "Nghiên cứu khoa học và triển khai ứng dụng trong lĩnh vực: công nghệ quan trắc môi trường, kiểm soát và xử lý ô nhiễm; hóa phân tích",
    html: `<div class="text-justify" style="font-family: Times New Roman, sans-serif">Nghiên cứu khoa học và triển khai ứng dụng trong lĩnh vực: công nghệ quan trắc môi trường, kiểm soát và xử lý ô nhiễm; hóa phân tích</div>`,
  },
  [TEMPLATE_45_FIELD.activity_two.value]: {
    text: "Dịch vụ thử nghiệm chất lượng sản phẩm, hàng hóa. Dịch vụ kiểm định, hiệu chuẩn, thử nghiệm phương tiện đo. Dịch vụ tư vấn về đầu tư, trang bị và quản lý phòng đo lường, thử nghiệm chất lượng sản phẩm; hàng hóa; tư vấn áp dụng các công cụ quản lý chất lượng; tư vấn xây dựng tiêu chuẩn; tư vấn xây dựng hệ thống bảo đảm về đo lường. Dịch vụ tư vấn chuyển giao công nghệ. Dịch vụ giám định công nghệ. Thông tin khoa học và công nghệ, đào tạo bồi dưỡng, nâng cao nghiệp vụ chuyên môn theo lĩnh vực đăng ký.(chỉ được cấp giấy chứng nhận, đối với việc cấp văn bằng, chứng chỉ phải được phép của cơ quan Nhà nước có thẩm quyền)",
    html: `<div class="text-justify" style="font-family: Times New Roman, sans-serif">Dịch vụ thử nghiệm chất lượng sản phẩm, hàng hóa. Dịch vụ kiểm định, hiệu chuẩn, thử nghiệm phương tiện đo. Dịch vụ tư vấn về đầu tư, trang bị và quản lý phòng đo lường, thử nghiệm chất lượng sản phẩm; hàng hóa; tư vấn áp dụng các công cụ quản lý chất lượng; tư vấn xây dựng tiêu chuẩn; tư vấn xây dựng hệ thống bảo đảm về đo lường. Dịch vụ tư vấn chuyển giao công nghệ. Dịch vụ giám định công nghệ. Thông tin khoa học và công nghệ, đào tạo bồi dưỡng, nâng cao nghiệp vụ chuyên môn theo lĩnh vực đăng ký. <span contenteditable="false" style="font-size: 10.5pt; font-family: Times New Roman, sans-serif" class="italic">(chỉ được cấp giấy chứng nhận, đối với việc cấp văn bằng, chứng chỉ phải được phép của cơ quan Nhà nước có thẩm quyền)</span></div>`,
  },
  [TEMPLATE_45_FIELD.activity_three.value]: {
    text: "Hợp tác với các tổ chức, cá nhân trong và ngoài nước theo lĩnh vực đăng ký phù hợp Luật định",
    html: `<div class="text-justify" style="font-family: Times New Roman, sans-serif">Hợp tác với các tổ chức, cá nhân trong và ngoài nước theo lĩnh vực đăng ký phù hợp Luật định</div>`,
  },
  [TEMPLATE_45_FIELD.signer.value]: {
    text: "",
    html: "",
  },
  [TEMPLATE_45_FIELD.sign_time.value]: {
    text: "05.02.2024 14:25:45 +07:00",
    html: "05.02.2024 14:25:45 +07:00",
  },
} as Record<
  keyof typeof TEMPLATE_45_FIELD,
  {
    text: string;
    html: string;
  }
>;

export const TEMPLATE_45_EMPTY_RAW_DATA = {
  [TEMPLATE_45_FIELD.reg_first_time.value]: {
    text: "",
    html: "............................",
  },
  [TEMPLATE_45_FIELD.reg_update_times.value]: {
    text: "",
    html: "............................",
  },
  [TEMPLATE_45_FIELD.org_name.value]: {
    text: "",
    html: "..............................................................................................................",
  },
  [TEMPLATE_45_FIELD.org_eng_name.value]: {
    text: "",
    html: "..............................................................................................................",
  },
  [TEMPLATE_45_FIELD.symbol.value]: {
    text: "",
    html: "...................................................................",
  },
  [TEMPLATE_45_FIELD.headquarters.value]: {
    text: "",
    html: ".................................................................................................................",
  },
  [TEMPLATE_45_FIELD.operating_loc.value]: {
    text: "",
    html: "........................................................................................................................................................................................................................................................................................................................................................................................................................................................................",
  },
  [TEMPLATE_45_FIELD.total_registered_capital.value]: {
    text: "",
    html: "..............................................................................",
  },
  [TEMPLATE_45_FIELD.fixed_capital.value]: {
    text: "",
    html: "..........................đồng",
  },
  [TEMPLATE_45_FIELD.working_capital.value]: {
    text: "",
    html: "............................đồng",
  },
  [TEMPLATE_45_FIELD.decision_establishment.value]: {
    text: "",
    html: "....................................................................................................................................................................................................................................",
  },
  [TEMPLATE_45_FIELD.direct_management_authority.value]: {
    text: "",
    html: "..................................................................................................................",
  },

  [TEMPLATE_45_FIELD.personal_name.value]: {
    text: "",
    html: `..............................................................................................`,
  },
  [TEMPLATE_45_FIELD.id_card.value]: {
    text: "",
    html: "..........................................................................",
  },
  [TEMPLATE_45_FIELD.issued_by.value]: {
    text: "",
    html: ".................................................................................................",
  },
  [TEMPLATE_45_FIELD.issued_date.value]: {
    text: "",
    html: "...............................................................................................",
  },
  [TEMPLATE_45_FIELD.registration_code.value]: {
    text: "",
    html: ".....",
  },
  [TEMPLATE_45_FIELD.activity_one.value]: {
    text: "",
    html: `<div style="font-family: Times New Roman, sans-serif;">............................................................................................................</div>`,
  },
  [TEMPLATE_45_FIELD.activity_two.value]: {
    text: "",
    html: `<div style="font-family: Times New Roman, sans-serif;">............................................................................................................</div><div style="font-family: Times New Roman, sans-serif;">............................................................................................................</div><div style="font-family: Times New Roman, sans-serif;">............................................................................................................</div><div style="font-family: Times New Roman, sans-serif;">............................................................................................................</div><div style="font-family: Times New Roman, sans-serif;">............................................................................................................</div><div style="font-family: Times New Roman, sans-serif;">............................................................................................................</div><div style="font-family: Times New Roman, sans-serif;">............................................................................................................</div><div style="font-family: Times New Roman, sans-serif;">............................................................................................................</div><div style="font-family: Times New Roman, sans-serif;">............................................................................................................</div><div style="font-family: Times New Roman, sans-serif;">............................................................................................................</div><div style="font-family: Times New Roman, sans-serif;">............................................................................................................</div><div style="font-family: Times New Roman, sans-serif;">............................................................................................................</div>`,
  },
  [TEMPLATE_45_FIELD.activity_three.value]: {
    text: "",
    html: `<div style="font-family: Times New Roman, sans-serif;">............................................................................................................</div><div style="font-family: Times New Roman, sans-serif;">............................................................................................................</div>`,
  },
  [TEMPLATE_45_FIELD.signer.value]: {
    text: "",
    html: "",
  },
  [TEMPLATE_45_FIELD.sign_time.value]: {
    text: "",
    html: "",
  },
} as Record<
  keyof typeof TEMPLATE_45_FIELD,
  {
    text: string;
    html: string;
  }
>;

export const TEMPLATE_45_CONTENT_LINES = {
  [TEMPLATE_45_FIELD.reg_first_time.value]: {
    min: 1,
    max: 1,
  },
  [TEMPLATE_45_FIELD.reg_update_times.value]: {
    min: 1,
    max: 1,
  },
  [TEMPLATE_45_FIELD.org_name.value]: {
    min: 1,
    max: 1,
  },
  [TEMPLATE_45_FIELD.org_eng_name.value]: {
    min: 1,
    max: 2,
  },
  [TEMPLATE_45_FIELD.symbol.value]: {
    min: 1,
    max: 1,
  },
  [TEMPLATE_45_FIELD.headquarters.value]: {
    min: 1,
    max: 3,
  },
  [TEMPLATE_45_FIELD.operating_loc.value]: {
    min: 1,
    max: 4,
  },
  [TEMPLATE_45_FIELD.total_registered_capital.value]: {
    min: 1,
    max: 1,
  },
  [TEMPLATE_45_FIELD.fixed_capital.value]: {
    min: 1,
    max: 1,
  },
  [TEMPLATE_45_FIELD.working_capital.value]: {
    min: 1,
    max: 1,
  },
  [TEMPLATE_45_FIELD.decision_establishment.value]: {
    min: 1,
    max: 2,
  },
  [TEMPLATE_45_FIELD.direct_management_authority.value]: {
    min: 1,
    max: 1,
  },
  [TEMPLATE_45_FIELD.personal_name.value]: {
    min: 1,
    max: 1,
  },
  [TEMPLATE_45_FIELD.id_card.value]: {
    min: 1,
    max: 1,
  },
  [TEMPLATE_45_FIELD.issued_by.value]: {
    min: 1,
    max: 1,
  },
  [TEMPLATE_45_FIELD.issued_date.value]: {
    min: 1,
    max: 1,
  },
  [TEMPLATE_45_FIELD.registration_code.value]: {
    min: 1,
    max: 1,
  },
  [TEMPLATE_45_FIELD.activity_one.value]: {
    min: 3,
    max: 5,
  },
  [TEMPLATE_45_FIELD.activity_two.value]: {
    min: 10,
    max: 13,
  },
  [TEMPLATE_45_FIELD.activity_three.value]: {
    min: 2,
    max: 4,
  },
  [TEMPLATE_45_FIELD.signer.value]: {
    min: 1,
    max: 1,
  },
  [TEMPLATE_45_FIELD.sign_time.value]: {
    min: 1,
    max: 1,
  },
} as Record<
  keyof typeof TEMPLATE_45_FIELD,
  {
    min: number;
    max: number;
  }
>;
